type BaseError = "ServerError" | "NetworkError";

export type UserRemoteDataSourceError = BaseError | "WrongPasswordError";
export const UserRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
  wrongPasswordError: () => new Error("WrongPasswordError"),
};

export type ProductsRemoteDataSourceError =
  | BaseError
  | "ProductNotFoundError"
  | "CategoryNotFoundError";
export const ProductsRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
  productNotFoundError: () => new Error("ProductNotFoundError"),
  categoryNotFoundError: () => new Error("CategoryNotFoundError"),
};

export type CategoriesRemoteDataSourceError = BaseError;
export const CategoriesRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type ConfigRemoteDataSourceError = BaseError;
export const ConfigRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type DiscountRemoteDataSourceError = BaseError;
export const DiscountRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type OrdersRemoteDataSourceError = BaseError;
export const OrdersRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type HomeRemoteDataSourceError = BaseError;
export const HomeRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type ColorsRemoteDataSourceError = BaseError;
export const ColorsRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};
